import { IElementTypeEditInfo } from './../models/index';

export const matchingEditInfo = {
    editExcludeFields: []
}